<template>
  <div id="app" v-cloak>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import Home from "./components/Home.vue";
import Works from "./components/Works.vue";
import Footer from "./components/Footer.vue";
import Nav from "./components/Nav.vue";

export default {
  name: "app",
  components: {
    Home,
    Works,
    Nav
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".sidenav");
      var instances = M.Sidenav.init(elems, {});
    });
  }
};
</script>

<style>
body {
  margin: 0px;
}
.page-footer .footer-copyright {
  display: block;
}
#modal-toggle {
  display: none;
}

@media screen and (max-width: 550px) {
  #modal-toggle {
    display: block;
  }
  #footer-tags {
    display: none;
  }
  .text-modal {
    text-decoration: underline;
  }
}
#app {
  font-family: "Quicksand", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#app .navbar-fixed nav {
  background: #f23847;
}

.logo {
  vertical-align: middle;
}

.navbar-fixed {
  z-index: 9999;
  /* position: fixed; */
}

hr {
  border: 2px solid #730202;
  padding: 1px;
  background-color: #730202;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
  left: -100px;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
